"use client"

import type React from "react"
import { motion } from "framer-motion"
import { FormData, Influencer } from "./types"
import { ToggleSwitch } from "../ui/toggle-switch-animated"
import { Card } from "../ui/card-animated"


interface ClausesRegulationsSectionProps {
  formData: FormData
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void
  influencer: Influencer
}

const slideUp = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
}

export const ClausesRegulationsSection: React.FC<ClausesRegulationsSectionProps> = ({
  formData,
  handleChange,
  influencer,
}) => {
  return (
    <Card title="Cláusulas y Regulaciones" delay={3}>
      <div className="space-y-4">
        <motion.div variants={slideUp} className="flex items-center justify-between">
          <label className="text-gray-700 font-medium pr-3 text-sm">
            Acepto las cláusulas y regulaciones del centro{" "}
            {influencer.branch.clauses_user && (
              <a
                href={influencer.branch.clauses_user}
                target="_blank"
                className="text-blue-600 underline hover:text-blue-800 transition-colors"
                rel="noreferrer"
              >
                (ver)
              </a>
            )}
          </label>
          <ToggleSwitch name="accept_clauses" checked={formData.accept_clauses} onChange={handleChange} disabled />
        </motion.div>

        <motion.div variants={slideUp} className="flex items-center justify-between">
          <label className="text-gray-700 font-medium pr-3 text-sm">
            El centro me ha informado suficientemente sobre las características de las actividades físicas y asumo
            voluntariamente los riesgos de la actividad.
            {influencer.branch.contract && (
              <a
                href={influencer.branch.contract}
                target="_blank"
                className="ml-1 text-blue-600 underline hover:text-blue-800 transition-colors"
                rel="noreferrer"
              >
                (ver contrato)
              </a>
            )}
          </label>
          <ToggleSwitch
            name="sufficiently_informed"
            checked={formData.sufficiently_informed}
            onChange={handleChange}
            disabled
          />
        </motion.div>

        <motion.div variants={slideUp} className="flex items-center justify-between">
          <label className="text-gray-700 font-medium pr-3 text-sm">
            Deseo recibir comunicaciones comerciales del centro.
          </label>
          <ToggleSwitch
            name="receive_communications"
            checked={formData.receive_communications}
            onChange={handleChange}
          />
        </motion.div>

        <motion.div variants={slideUp} className="flex items-center justify-between">
          <label className="text-gray-700 font-medium pr-3 text-sm">
            Concedo derechos de imagen para fotografías y grabaciones tomadas durante actividades y eventos en el
            centro.
          </label>
          <ToggleSwitch name="image_rights" checked={formData.image_rights} onChange={handleChange} />
        </motion.div>
      </div>
    </Card>
  )
}
